import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { ScriptLoaderService } from '../../../../website/shared/services/src/lib/script-loader/script-loader.service';
import { CheckoutService } from '../../../../website/shared/services/src/lib/checkout/checkout.service';
import { environment } from '../../../../../apps/website/src/environments/environment';
import { CountriesService } from '@boma/supplier-portal/shared/services';
import { PaymentsFacade } from '@boma/shared/common';
import { IOrder } from '@boma/website/shared/entities';

@Component({
  selector: 'boma-payment-gateway',
  templateUrl: './boma-payment-gateway.component.html',
  styleUrls: ['./boma-payment-gateway.component.scss'],
})
export class BomaPaymentGatewayComponent implements OnInit, OnChanges {
  @Input() paymentAmount: number = null;
  @Input() customer = null;
  @Input() orders: IOrder[] | null = null;
  @Input() charges = null;
  @Input() profile;
  encrypted = false;
  encrypting = false;
  loaded = false;
  countryCode: string;
  batch: string[];

  savingTransaction$ = this.paymentFacade.savingTransaction$;

  // merchantTransactionID:BMTT-80102242
  // currencyCode:ZMW
  // requestAmount:299
  // countryCode:ZM
  // accountNumber:55923655
  // serviceCode:BOMDEV0600
  // dueDate:2023-10-17 00:00:00
  // requestDescription:Getting service/good x
  // customerFirstName:Elaina
  // customerLastName:Hickle
  // MSISDN:84-576-665-0723
  // customerEmail:Ewell.Wilkinson47@hotmail.com
  // paymentWebhookUrl:https://www.boma.today/payment/confirm
  // successRedirectUrl:https://www.boma.today/payment/success
  // failRedirectUrl:https://www.boma.today/payment/failed
  // payerModeID:266
  // languageCode:EN

  constructor(
    private scriptService: ScriptLoaderService,
    private checkoutService: CheckoutService,
    private countryService: CountriesService,
    private paymentFacade: PaymentsFacade
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      this.orders?.length &&
      this.charges?.length &&
      this.paymentAmount &&
      !this.loaded
    ) {
      this.loaded = true;
      console.log(this.profile.selectedLocation);
      this.batch = [...new Set(this.orders.map((o) => o.batchId))];

      this.countryService.getMobilePrefixes().subscribe((payload) => {
        console.log(this.profile.selectedLocation.country.name);
        payload.data.map((c) => {
          if (c.name === this.profile.selectedLocation.country.name) {
            this.countryCode = c.code;
          }
        });
      });
    }
  }

  initialiseTinggButton() {
    this.scriptService
      .load('tinggcheckout')
      .then((data) => {
        // @ts-ignore
        Tingg.renderPayButton({
          className: 'awesome-checkout-button',
          text: 'Proceed to Payment',
          color: 'green',
        });
      })
      .catch((error) => console.log(error));
  }

  doThatTingg(tinggObject) {
    //DO CHECKOUT REQUEST

    if (!this.encrypted) {
      this.encryptParameters();
      return;
    }
    const checkoutType = 'redirect';
    // @ts-ignore
    Tingg.renderCheckout({
      checkoutType,
      merchantProperties: {
        params: tinggObject.param,
        accessKey: tinggObject.accessKey,
        countryCode: tinggObject.countryCode,
      },
      // or 'modal' ‘redirect’
    });
  }

  encryptParameters() {
    console.log(this.batch);
    if (!this.batch || this.batch.length > 1) {
      console.log('Too many batches');
      return;
    }

    if (!this.paymentAmount || this.paymentAmount <= 0) return;
    if (this.encrypting) return;
    this.encrypting = true;

    const paymentRequest = this.batch[0];

    const paymentDate = new Date();
    paymentDate.setFullYear(paymentDate.getFullYear() + 1);
    paymentDate.setMinutes(paymentDate.getMinutes() + 180);

    // MUCH EASIER CONVERTING THE ISO STRING
    var dueDate = new Date(paymentDate).toISOString();
    dueDate = paymentDate
      .toISOString()
      .slice(0, dueDate.indexOf('.'))
      .replace('T', ' ');

    // console.log(dueDate);

    // console.log(new Date(paymentDate));

    ///dueDate: "2019-06-01 23:59:59", //Must be a future date/
    //2022-11-20 1:43:56

    //TODO WE NEED TO ADD THE COUNTRY 2 LETTER ISO CODES TO THE DATABASE

    const supplierServiceCode = null; // Check if we process this supplier directly to tingg

    //TODO CUSTOMER NAME AND SURNAME NEEDS TO BE SPLIT

    const params = {
      merchantTransactionID: paymentRequest,
      customerFirstName: this.profile.selectedLocation?.contactPersonName,
      customerLastName: this.profile.selectedLocation?.contactPersonName,
      msisdn:
        this.profile.selectedLocation.contactPersonNumber || '+260970000000', // telephone number
      customerEmail:
        this.profile.selectedLocation?.notficationEmailAddress ||
        'francois@taptapsol.com',
      requestAmount: this.paymentAmount.toFixed(2).toString(),
      currencyCode: this.profile.selectedLocation.country.isoCurrencySymbol,
      accountNumber: paymentRequest,
      serviceCode: supplierServiceCode || environment.tingg.serviceCode,
      dueDate: dueDate,
      requestDescription: 'Testing transaction from API',
      countryCode: this.countryCode,
      languageCode: 'EN',
      successRedirectUrl:
        environment.apiRoute + 'api/v1.0/Checkout/Tingg/Payment/Success',
      failRedirectUrl: environment.tingg.failedRedirectUrl,
      paymentWebhookUrl: environment.tingg.paymentWebhookUrl,
    };

    this.checkoutService.encryptPaymentRequest(params).subscribe(
      (x) => {
        console.log('encrypted params:', x);
        if (x.param && x.accessKey && x.countryCode) {
          this.encrypted = true;
        } else {
          this.encrypted = false;
        }
        this.encrypting = false;

        this.doThatTingg(x);
      },
      (error) => {
        console.log(error);
        this.encrypting = false;
      }
    );
  }

  initializePayment() {
    this.paymentFacade
      .createTransactionForBatch(this.batch[0])
      .subscribe((transaction) => {
        if (!transaction?.paymentUrl) return;

        window.location.href = transaction.paymentUrl;
      });
  }
}
